// extracted by mini-css-extract-plugin
module.exports = {"cursor":"client_cursor__3XiIi","firstRowMargin":"client_firstRowMargin__2t10V"};